export const rxSpaces = /[\s\uFEFF\xA0]+/g
export const rxRegexpReplace = /[-/\\^$*+?.()|[\]{}]/g
